///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import graphLogoImg from '../images/pie-logo.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark, faMoon, faSun, faRightFromBracket, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';
import ConfirmBox from './ConfirmBox';
import { subscriptionNames } from '../services/SubscriptionsService';

const Header = () => {
    const [type, setType] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [isDark, setIsDark] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const headerRef = useRef(null)

    const { logout, currentUser, userData } = useAuth()

    useEffect(() => {
        let currentTheme = localStorage.getItem('display-theme')
        if(currentTheme === null) {
            localStorage.setItem('display-theme', 'dark')
            currentTheme = 'dark'
            setIsDark(true)
        }

        if(currentTheme === 'light') {
            document.documentElement.setAttribute('display-theme', 'light');
            localStorage.setItem('display-theme', 'light')
            setIsDark(false)
        }
        else if(currentTheme === 'dark') {
            document.documentElement.setAttribute('display-theme', 'dark');
            localStorage.setItem('display-theme', 'dark')
            setIsDark(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    useEffect(() => {
        if (!userData || !userData.subscriptions || userData.subscriptions.length === 0) return
        const uSub = userData.subscriptions[0]
        if (Object.keys(uSub).length === 0) return
        if (!uSub.valid || uSub.manualDisable) return
        setType(subscriptionNames(uSub.name))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData.subscriptions])

    const switchTheme = () => {
        if(isDark) {
            document.documentElement.setAttribute('display-theme', 'light');
            localStorage.setItem('display-theme', 'light')
        }
        else {
            document.documentElement.setAttribute('display-theme', 'dark');
            localStorage.setItem('display-theme', 'dark')
        }
        setIsDark(!isDark)
    }

    const navigate = useNavigate();

    const goHomeToSection = async (section) => {
        navigate('/')
        await new Promise(r => setTimeout(r, 200));
        scrollToId(section)
    }

    const scrollToId = (idName) => {
        const elem = document.getElementById(idName);
        if(elem === null) return
        elem.scrollIntoView({behavior: 'smooth'}, true);
    }

    const switchPage = (link) => {
        setIsOpen(false)
        if(currentUser) {
            switch(link) {
                case '/':
                    navigate(link)
                    break;
                case 'sign-in':
                    break;
                default:
                    break;
            }
        }
        else navigate(link)
    }

    const handleLogOut = () => {
        setOpenConfirm(false)
        logout()
    }

    return (
    <>
    <div className={`hd-wrapper${scrolled ? ' hd-wrapper--scrolled' : ''}`} ref={headerRef}>
        <div className={`hd-bar${isOpen ? ' hd-bar--open' : ''}`}>
            {/* Logo — keeps original animation class */}
            <div className='logo-image' onClick={() => switchPage('/')}>
                <img src={graphLogoImg} placeholder='logo-img' alt='Program Intrastat logo' />
                <span className="hd-brand">programintrastat.ro</span>
                {type !== '' && <span className='hd-sub-badge'>{type}</span>}
            </div>

            {/* Mobile toggle */}
            <button className="hd-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Meniu">
                <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
            </button>

            {/* Nav */}
            <nav className={`hd-nav${isOpen ? ' hd-nav--open' : ''}`}>
                {!currentUser && (
                    <div className="hd-nav__links">
                        <button className="hd-nav__link" onClick={() => { switchPage('/'); goHomeToSection('wp-how'); }}>
                            Cum funcționează
                        </button>
                        <button className="hd-nav__link" onClick={() => goHomeToSection('pricing')}>
                            Tarife
                        </button>
                        <button className="hd-nav__link" onClick={() => switchPage('/verificare-xml-intrastat')}>
                            Verifică XML
                        </button>
                        <button className="hd-nav__link" onClick={() => switchPage('/docs')}>
                            Documentație
                        </button>
                        <button className="hd-nav__link" onClick={() => switchPage('/contact')}>
                            Contact
                        </button>
                    </div>
                )}

                {currentUser && (
                    <div className="hd-user" onClick={() => switchPage('/')}>
                        <span className="hd-user__name">{currentUser.displayName}</span>
                        <span className="hd-user__email" style={{userSelect:'all'}}>{currentUser.email}</span>
                    </div>
                )}

                <div className="hd-nav__actions">
                    <button
                        className="hd-theme-btn"
                        onClick={switchTheme}
                        data-tip
                        data-for="theme-hover"
                        aria-label="Schimbă tema"
                    >
                        <FontAwesomeIcon icon={isDark ? faSun : faMoon} />
                    </button>

                    {currentUser && (
                        <button
                            className="hd-logout-btn"
                            onClick={() => setOpenConfirm(true)}
                            data-tip
                            data-for="logout-hover"
                            aria-label="Ieșire din cont"
                        >
                            <FontAwesomeIcon icon={faRightFromBracket} />
                        </button>
                    )}

                    {!currentUser && (
                        <button className="hd-cta" onClick={() => switchPage('/sign-in')}>
                            Cont
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    )}
                </div>
            </nav>
        </div>
    </div>
    <div className='after-header'></div>

    <ReactTooltip effect="solid" id='theme-hover' type={isDark ? 'light' : 'dark'}>Schimbă tema</ReactTooltip>
    <ReactTooltip effect="solid" id='logout-hover' type={isDark ? 'light' : 'dark'}>Ieșire din cont</ReactTooltip>
    {openConfirm &&
    <ConfirmBox
        onConfirm = {() => handleLogOut()}
        onClose = {() => setOpenConfirm(false)}
        content = 'Sigur doriți să ieșiți din cont?'
        title = 'Confirmați delogarea'
    />
    }
    </>
    )
}

export default Header
